/** Shared copy: Credentials Vault product page + home FeaturesSection */
export const credentialVaultMarketingSixBoxes = [
  {
    title: 'Corporate Level Credentials',
    description:
      'Store all corporate level credentials and share the relevant ones with your team. ',
  },
  {
    title: 'Personal Level Credentials',
    description:
      'Use the same flowdo account to store your personal credentials. Easy to check, copy and use on relevant websites.',
  },
  {
    title: 'Highly Encrypted',
    description:
      '2-levels of AES-256-GCM encryption. Decryption is using a master password that you only have access to.',
  },
  {
    title: 'Free to Use',
    description:
      'This service is free to use and does not require any subscription or credit card.',
  },
  {
    title: 'Secure Sharing',
    description:
      'Share credentials through flowdo without the worry of exposing the credentials. You can share with select departments or users. Access based controls are possible. ',
  },
  {
    title: 'History and Tracking ',
    description:
      'flowdo keeps track of all the copying, editing or sharing of the credentials allowing you to track full access details. ',
  },
];
